export default {"src":"/_next/static/media/email-icon.a1f235d3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};